/**
 * Shares Redux Slice
 */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { get, post } from '../../services/api/axiosInstance';
import { API_ENDPOINTS } from '../../services/api/apiEndpoints';

export const fetchShares = createAsyncThunk(
  'shares/fetchAll',
  async (params, { rejectWithValue }) => {
    try {
      const response = await get(API_ENDPOINTS.SHARES.BASE, params);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  }
);

const sharesSlice = createSlice({
  name: 'shares',
  initialState: {
    shares: [],
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchShares.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchShares.fulfilled, (state, action) => {
        state.isLoading = false;
        state.shares = action.payload.data || action.payload;
      })
      .addCase(fetchShares.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = sharesSlice.actions;
export default sharesSlice.reducer;
